import { PanelBar, PanelBarItem, PanelBarSelectEventArguments } from '@progress/kendo-react-layout'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { UserApi } from '../../../redux/api/UserApi'
import { Scrollbars } from 'react-custom-scrollbars-2';
import './Contacts.scss'
import { InputClearValue, InputPrefix, TextBox } from '@progress/kendo-react-inputs';
import { Icon } from "@progress/kendo-react-common";
import { IContact, IContactSearchProps } from '../../../types/User/IContact';
import { Badge, BadgeContainer, Loader } from '@progress/kendo-react-indicators';
import { Fav } from '../../User/Fav';
import { ContactsMenu, MenuProps } from './ContactsMenu';
import { RevUserContext } from '../../../context/UserContext';
import { FavoriteApi } from '../../../redux/api/FavoriteApi';
import { ContactCard } from './ContactCard';
import { IUser } from '../../../types/User/IUser';
import { useReduxDispatch, useReduxSelector } from '../../../redux/hooks';
import * as RevelationSlice from '../../../slices/RevelationSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { IUserProfile } from '../../../types/User/IUserProfile';
import { ToolProps } from '../ActivityFeed/ActivityFeed';
import { useDebounce } from 'use-debounce';
import { Setting } from '../../../types/Setting/Setting';
import { Settings } from './Settings';
import { ContactOptions } from './ContactOptions';
import { HeaderOptions } from '../HeaderOptions';
import { HeaderMenu } from './HeaderMenu';
import { updateToggleState } from "../../../slices/RightBarSlice";
import { ToggleState } from '../RightBar';

export type ContactsProps = ToolProps & {
    selectedContact?: IContact
}

export const Contacts = (props: ContactsProps) => {
    const navigate = useNavigate()
    const profile = useContext<IUserProfile>(RevUserContext)
    const dispatch = useReduxDispatch()
    const { currentIframeSrc } = useReduxSelector(state => state.revI)
    const [filter, setFilter] = useState<string>('')
    const [filterText, setFilterText] = useState<string>('')
    const debouncedSearchTerm = useDebounce(filterText, 500);
    const [page, gotoPage] = useState<string>('')
    const [menu, setMenu] = useState<MenuProps<ContactOptions>>()
    const [popupSettingsVisible, setPopupSettingsVisible] = useState(false);
    const [headerMenu, setHeaderMenu] = useState<MenuProps<HeaderOptions>>()
    const { data: config } = FavoriteApi.useGetFavoriteConfigQuery(profile.Uid, { skip: !profile?.Features?.Revelations });
    const [favOnly, setFavOnly] = useState<boolean>(profile?.Features.Revelations && config?.Contacts_Search_Favs_Only)
    const [saveFavConfig] = FavoriteApi.useSaveFavoriteConfigMutation();
    const [expanded, setExpanded] = useState<string[]>() //all groups expanded by default
    const [contactSelected, setContactSelected] = useState<IContact>() //all groups expanded by default
    const { data: contacts, isFetching } = UserApi.useGetContactsQuery({ uid: profile.Uid, filter: filter, favsOnly: favOnly, pageLetter: page, groupByOffice: !config?.Contacts_Search_By_Name, thisContactId: contactSelected?.ID } as IContactSearchProps)
    const { data: mimicSetting } = UserApi.useGetSettingQuery(Setting.Mimic);

    useEffect(() => {
        console.log('props.selectedContact', props.selectedContact)
        setFavOnly(false)
        setFilterText(props.selectedContact?.FullName)
        setFilter(props.selectedContact?.FullName)      //Will cause fetch
        setContactSelected(props.selectedContact)
    }, [props.selectedContact])

    //Change favorites when mimicing an account
    useEffect(() => {
        setFavOnly(profile?.Features.Revelations && config?.Contacts_Search_Favs_Only)
    }, [profile, config])


    useEffect(() => {
        //console.log('debouncedSearchTerm', debouncedSearchTerm[0])
        setFilter(debouncedSearchTerm[0])
    }, [debouncedSearchTerm])

    const handleSelect = async (event: PanelBarSelectEventArguments) => {
        setExpanded(event.expandedItems);
        //event.target.props.id && setExpandedContactId(event.target.props.id)
        setMenu(null);
    }

    const toggleFavorites = () => {
        //let newFavs = !favOnly;
        setFavOnly(f => !f)
        saveFavConfig({ uid: profile.Uid, config: { ...config, Contacts_Search_Favs_Only: !config?.Contacts_Search_Favs_Only } });
    }

    const toggleByOffice = () => {
        saveFavConfig({ uid: profile.Uid, config: { ...config, Contacts_Search_By_Name: !config?.Contacts_Search_By_Name } });
    }

    const itemsToRender = useMemo(() => {
        //console.log('itemsToRender')
        const groups = [...new Set(contacts?.ReturnValue.map(g => g.Group_Value))]

        console.log('setExpanded', groups, expanded, contacts?.ReturnValue.length, contactSelected?.ID)
        if (contactSelected) {
            let newExpanded = [...groups, contactSelected.ID.toString()];

            setExpanded(newExpanded)
            //setContactSelected(null)
        }
        else {
            setExpanded(groups)
        }

        return groups.map(g => {
            let _children = contacts?.ReturnValue.filter(c => c.Group_Value === g).map(c => {
                return {
                    id: c.ID.toString(),
                    title: c.FullName,
                    favId: c.Fav_Id,
                    contactId: c.ID,
                    imageUrl: c.Profile_Image_Path,
                    url: `/deeplink?url=/contacts/contactinfo.aspx?contact_id=${c.ID}`,
                }
            })
            return {
                id: g.toString(),
                title: `${g}`,
                //title: `${cid.toString()} ${favorites.find(f => f.Category_Id === cid).Category_Name} (${_children.length}) ${expanded.indexOf(cid.toString()) > -1}`,
                //imageUrl: favorites.find(f => f.Category_Id === cid).Category_Image_Url,
                children: _children
            }
        });
    }, [contacts, contactSelected]);

    const addNewContact = () => {
        dispatch(RevelationSlice.updateIframeSrc(`/contacts/contactinfo.aspx`))
    }

    const HeaderOptions = [
        {
            id: "filter",
            title: `Filter`,
            image: './images/Dock/Edit.png',
            onclick: () => {
                setPopupSettingsVisible(true);
            },
            element:
                <BadgeContainer>
                    {config?.Client_Type_Ids?.split(',').length &&
                        <Badge align={{ horizontal: 'start', vertical: 'top' }}>
                            {config?.Client_Type_Ids?.split(',').length}
                        </Badge>
                    }
                    <button className='icon settings k-font-icon k-i-filter' title='Filter Settings'></button>
                </BadgeContainer>,
            visible: true
        },
        {
            id: "new",
            title: `Add New ${profile?.Phrases.Contact}`,
            //image: './images/Add-Contact.png',
            element: <button className='icon settings k-font-icon k-i-add' title='Add new'></button>,
            onclick: addNewContact,
            visible: profile?.Features.Add_Edit_EndUSer_From_LogACall
        },
        {
            id: "toggle",
            title: `Group by Name or Address`,
            //image: config?.Contacts_Search_By_Name ? './images/contacts-by-person-icon-dark.png' : './images/contacts-by-company-icon.png',
            element: config?.Contacts_Search_By_Name
                ? <button className='icon settings k-font-icon k-i-group' title='Grouped by Name'></button>
                : <button className='icon settings k-font-icon k-i-ungroup' title='Grouped by Address'></button>,
            onclick: toggleByOffice,
            visible: true
        },
        {
            id: "fav",
            title: `Toggle favorites`,
            image: favOnly ? './images/Fav_Color.png' : './images/Fav_Grey.png',
            onclick: toggleFavorites,
            visible: profile?.Features.Revelations
        },
        {
            id: "win",
            title: `Open in New Window`,
            //image: 'images/ibutton_revelations_popout_black.png',
            element: <button className='icon settings k-font-icon k-i-hyperlink-open' title='Open in New Window'></button>,
            link: '/Contacts',
            visible: !props.fullScreen
        }
    ] as HeaderOptions[]

    const ContactOptions = [
        {
            id: "edit",
            title: `Edit ${profile.Phrases.Contact}`,
            image: './images/Dock/Edit.png',
            onclick: (user: IUser) => {
                dispatch(RevelationSlice.updateIframeSrc(`/contacts/contactinfo.aspx?contact_Id=${user.ID}`))
                props.itemSelected();
            },
            visible: true
        },
        {
            id: "log",
            title: `New ${profile?.Phrases.CallPhrase}`,
            //icon: 'k-i-plus-outline',
            image: './images/Dock/New-Ticket.png',
            //link: `/ticket/details?endUserId=${contact?.UId}`,
            onclick: (user: IUser) => {
                navigate(`/ticket/new/details?endUserId=${user?.UId}`)
                props.itemSelected();
            },
            visible: true
        },
        {
            id: "find",
            title: `Find open ${profile?.Phrases.CallPhrase}s`,
            //icon: 'k-i-search',
            image: './images/Dock/Find-Open-Ticket.png',
            onclick: (user: IUser) => {
                dispatch(RevelationSlice.updateIframeSrc(`/Search/Default.aspx?RunSearch=True&SearchTypes=1&Filters=End_User=${user.ID}~!~Ticket_Status_Type=1;2;4`))
                props.itemSelected();
            },
            visible: true
        },
        {
            id: "add_asset",
            title: `Add ${profile?.Phrases.Asset}s`,
            //icon: 'k-i-plus',
            image: './images/Dock/Add-Assets.png',
            onclick: (user: IUser) => {
                navigate('/asset');
                props.itemSelected();
            },
            visible: profile.Features.Add_Asset
        },
        {
            id: "find_asset",
            title: `Find ${profile?.Phrases.Asset}s`,
            //icon: 'k-i-search',
            image: './images/Dock/Find-Assets.png',
            onclick: (user: IUser) => {
                dispatch(RevelationSlice.updateIframeSrc(`/Search/Default.aspx?RunSearch=True&SearchTypes=7&Filters=End_User=${user.ID}`))
                props.itemSelected();
            },
            visible: profile.Features.View_Assets
        },
        {
            id: "mimic",
            title: `Mimic user account`,
            //icon: 'k-i-eye',
            image: './images/Dock/Mimic-User-Account.png',
            onclick: (user: IUser) => {
                dispatch(RevelationSlice.mimicUser(user?.UId))

                navigate('/')

                props.itemSelected();
            },
            visible: profile.Features.Super_Admin && mimicSetting?.Bool_Value
        }
    ] as ContactOptions[]


    const headerRef = useRef<HTMLButtonElement>();
    return (
        <section className='contacts' onMouseLeave={props.onMouseLeave}>
            <header className='right-bar-header' >
                <img alt='contacts' className='icon' src='./images/Contacts-Dark.png' width='25' height='25' style={{ alignContent: 'center' }} /><span className='text'>Contacts</span>
                {/* {profile?.Features.Add_Edit_EndUSer_From_LogACall && <button className='icon add' onClick={addNewContact} title='Add new Contact' ><img alt='Add new contact' src='./images/Add-Contact.png' style={{ alignContent: 'center' }} /></button>}
                <button className='icon contact-group' onClick={toggleByOffice} title='Group by name or address' ><img alt='Group by name or address' src={config?.Contacts_Search_By_Name ? './images/contacts-by-person-icon.png' : './images/contacts-by-company-icon.png'} style={{ alignContent: 'center' }} /></button>
                {profile?.Features.Revelations && <button className='icon contact-fav' onClick={toggleFavorites} title='Toggle favorites' ><img alt='toggle contact favorites' src={favOnly ? './images/Fav_Color.png' : './images/Fav_White.png'} style={{ alignContent: 'center' }} /></button>}
                {!props.fullScreen && <a className='icon window' href='/Contacts' target={'_blank'}><img alt='pop out contacts bar' src='./images/contacts-pop-out.png' style={{ alignContent: 'center' }} title='Open in new window' /></a>} */}
                <button ref={headerRef} className='icon k-font-icon k-i-more-horizontal' title='More options' onClick={(e) => {
                    console.log('top', headerRef.current.offsetTop, 'left', headerRef.current.offsetLeft);

                    setHeaderMenu((m) => { return { ...m, visible: !m?.visible, offset: { top: e.clientY + 30, left: e.clientX - 170 } } })
                }} />
                {!props.fullScreen && <button className='icon lock' onClick={props.unlocked} title='Unlock side-bar' ><img alt='lock contacts bar' src='./images/Lock.png' style={{ alignContent: 'center' }} /></button>}
                {!props.fullScreen && <button className='icon unlock' onClick={props.locked} title='Lock side-bar' ><img alt='unlock contacts bar' src='./images/Unlock.png' style={{ alignContent: 'center' }} /></button>}
            </header>
            <Settings popupToggled={(v) => setPopupSettingsVisible(v)} showPopup={popupSettingsVisible} badgeCount={config?.Client_Type_Ids?.split(',').length} />
            <HeaderMenu {...headerMenu} options={HeaderOptions.filter(o => o.visible)} itemClicked={() => setHeaderMenu(null)} />
            <ContactsMenu {...menu} options={ContactOptions.filter(o => o.visible)} itemClicked={() => setMenu(null)} />
            <div className='contact-search-wrapper'>
                <TextBox className='contact-search'
                    value={filterText}
                    onChange={(e) => {
                        console.log('onChange')
                        setContactSelected(null);
                        //setSomething(true);
                        setFilterText(e.value.toString())
                        gotoPage(null);

                    }}
                    placeholder="Search..."
                    prefix={() => (
                        <InputPrefix>
                            <Icon name="search" />
                        </InputPrefix>)
                    }
                    suffix={() => (
                        <>
                            {filterText && (
                                <InputClearValue onClick={() => {
                                    setContactSelected(null);
                                    setFilterText('')
                                    setFilter('')
                                }}>
                                    <Icon name="x" />
                                </InputClearValue>
                            )}
                            {isFetching && <Loader type='pulsing' themeColor='secondary' />}
                        </>
                    )}
                />
            </div>
            <p className='pager'>
                {
                    contacts?.Pages?.map(p => {
                        return <button className={itemsToRender.find(i => i.title === p.Letter) ? 'selected' : ''} disabled={p.RecordCount === 0} key={p.Letter} title={`${p.RecordCount} items`} onClick={(e) => { gotoPage(p.Letter); }}>{p.Letter}</button>
                    })}
            </p>
            {contacts && itemsToRender.length === 0 && <div className='no-found'>No contacts found </div>}
            <Scrollbars autoHeight={false}>
                <PanelBar
                    animation={false}
                    isControlled={true}
                    className='contact-list'
                    expanded={expanded}
                    onSelect={handleSelect}
                >
                    {itemsToRender.map(c => {
                        // Header
                        return <PanelBarItem key={c.id.toString()} id={c.id.toString()} title={`${c.title}`} className="category-item">
                            {c.children.map(i => {
                                // Contacts
                                return <PanelBarItem title={
                                    <>
                                        <Fav name={i.title} favId={i.favId} contactId={i.contactId} />
                                        <button title='Click for more options' className='contact-name' onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setMenu((menu) => { return { visible: !menu?.visible, offset: { top: e.clientY, left: e.clientX }, contactId: i.contactId } as MenuProps<ContactOptions> })

                                        }}>{i.title}</button>
                                    </>
                                } id={i.id.toString()} key={`c-${i.id.toString()}-${i.favId}`} >
                                    <ContactCard options={ContactOptions.filter(o => o.visible)} id={parseInt(i.id)} fieldsCSV={contacts.ContactsDockFields} fieldLabels={contacts.FieldLabels} />
                                </PanelBarItem>
                            })}
                        </PanelBarItem>
                    })}
                </PanelBar>
            </Scrollbars>
        </section >
    )
}



